import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './article.scss';

const Article = ({article}) => {
    return (
        <div className="article">
            <div className="article-head">
                <div className="icon-first">
                    <FontAwesomeIcon className="icon-folder" icon='folder-open' />
                </div>
                <div className="icon-second">
                    <FontAwesomeIcon icon='eye'/>
                </div>
            </div>
            <h3>{article.title}</h3>
            <p>{article.content}</p>
            <div className="lang">
                {
                article.languages.map(link => <span className="lan">{link}</span>)
            }
            </div>
        </div>
    );
};

export default Article;